<template>
  <b-overlay :show="show_overlay" rounded="sm">
    <b-card class="mt-2">
      <template #header>
        <div class="row justify-content-between">
          <div class="col-auto">
            <b-badge variant="success" class="mr-2 fs-6">
              Campanhas /
              {{ this.$store.getters['pedidoInfo'].nome }} -
              {{
                this.$store.getters['pedidoInfo'].situacao === 'P' ||
                this.$store.getters['pedidoInfo'].situacao === 'A'
                  ? 'Alteração '
                  : 'Cadastro '
              }}
              {{ 'Pedidos das Filiais' }}
            </b-badge>
          </div>
          <b-overlay class="col-auto ml-2" :show="show_overlay" rounded="sm">
            <b-button @click="gravaPedidos" variant="primary">
              Confirmar Pedidos
            </b-button>
          </b-overlay>
        </div>

        <div class="col-auto">
          <h5>
            {{
              'Valor Minimo do Pedido: ' +
              format(this.valorMinimoPedido, config)
            }}
          </h5>
        </div>

        <div class="col-auto">
          <h5>
            {{
              this.valorMinimoParcela > 0
                ? 'Valor Minimo da Parcela: ' +
                  format(this.valorMinimoParcela, config)
                : 'Valor Minimo da Parcela: -'
            }}
          </h5>
        </div>
      </template>

      <ConfirmDialog>
        <template #message="slotProps">
          <div class="flex p-4">
            <i :class="slotProps.message.icon" style="font-size: 1.5rem"></i>
            <p class="pl-2">{{ slotProps.message.message }}</p>
          </div>
        </template>
      </ConfirmDialog>

      <DataTable
        :value="listaPedidosInfos"
        class="p-datatable-sm"
        responsiveLayout="scroll"
        selectionMode="single"
        dataKey="id"
        v-model:expandedRows="expandedRows"
        :paginator="true"
        :rows="10"
      >
        <Column />
        <Column :expander="true" headerStyle="width: 3rem" />
        <Column field="fazer_pedido" header="Fazer Pedido?" :sortable="false">
          <template #body="item">
            <b-form-checkbox
              class="ml-4"
              v-model="item.data.fazer_pedido"
            ></b-form-checkbox>
          </template>
        </Column>
        <Column
          header="Status do Pedido"
          field="qtde"
          class=""
          :style="{
            position: 'relative',
            width: '15rem',
          }"
          :sortable="false"
        >
          <template #body="item">
            <b-form-group class="pt-1 mr-3">
              <div
                class="d-flex justify-content-center align-items-center text-white py-1 status"
                :class="{
                  'bg-success': item.data.ehValido,
                  'bg-danger': !item.data.ehValido,
                }"
              >
                <BootstrapIcon
                  v-show="!item.data.ehValido"
                  icon="hand-thumbs-down"
                  color="white"
                />

                <BootstrapIcon
                  v-show="item.data.ehValido"
                  icon="hand-thumbs-up"
                  color="white"
                />
                <span class="ml-2">{{ item.data.mensagem }}</span>
              </div>
            </b-form-group>
          </template>
        </Column>

        <Column field="nomereduzido" header="Cód. Farmácia" :sortable="true">
          <template #body="item">
            <div class="mr-2">
              {{ item.data.nomereduzido }}
            </div>
          </template>
        </Column>
        <Column field="nome" header="Nome Farmácia" :sortable="true">
          <template #body="item">
            <div class="mr-2">
              {{ item.data.nome }}
            </div>
          </template>
        </Column>
        <Column field="cnpjcpf" header="CNPJ" :sortable="true">
          <template #body="item">
            <div class="mr-3">
              {{ item.data.cnpjcpf }}
            </div>
          </template>
        </Column>
        <Column field="endereco" header="Endereço" :sortable="true">
          <template #body="item">
            <div class="mr-2">
              {{ item.data.endereco }}
            </div>
          </template>
        </Column>

        <template #expansion="item">
          <ListProdutosFarmacias
            :pedidoInfo="item.data"
            :valorMinimoPedido="this.valorMinimoPedido"
            :valorTotal="this.valorTotal"
            @validaPedido="this.validaPedido"
          />
        </template>
      </DataTable>
    </b-card>
  </b-overlay>
</template>
<script>
import service from '@/services/BaseService'

import { format } from 'v-money3'
import config from '@/functions/formatMoney'
import ConfirmDialog from 'primevue/confirmdialog'

import ListProdutosFarmacias from './ListProdutosFarmacias.vue'

export default {
  props: [
    'pedidoPrincipalInfo',
    'valorMinimoPedido',
    'valorMinimoParcela',
    'valorTotal',
  ],
  components: {
    ListProdutosFarmacias,
    ConfirmDialog,
  },
  data() {
    return {
      format: format,
      config: config,
      show_overlay: false,
      interval_id: 0,
      listaPedidosInfos: [],
      listaProdutos: [],
      expandedRows: [],
    }
  },
  created() {
    this.getListaFarmacias()
  },
  mounted() {
    this.interval_id = window.setInterval(() => {
      this.$toast.warning('Salve pedidos em aberto para não perder os dados!')
    }, 900000)
  },
  methods: {
    gravaPedidos() {
      this.$confirm.require({
        message:
          'Deseja prosseguir com a confirmação de pedido(s)? Pedidos inválidos serão salvos com status Aberto e pedidos válidos serão salvos com status Pedido!',
        header: 'Confirmação de Pedido(s)!',
        icon: 'pi pi-info-circle',
        acceptClass: 'p-button-success',
        accept: async () => {
          this.$emit('gravaPedidos')
          window.clearInterval(this.interval_id)
          this.$emit('backToList')
        },
      })
    },
    calculaValorSubpedido(listaProdutos) {
      var valorTotal = 0
      for (let i = 0; i < listaProdutos.length; i++) {
        valorTotal += parseFloat(
          parseFloat(listaProdutos[i].valor_unitario) *
            parseInt(listaProdutos[i].quant_solicitada),
        )
      }

      return valorTotal
    },
    async gravar() {
      this.show_overlay = true
      const subpedidos = this.$store.getters['multiplosPedidos']
      if (subpedidos.length > 0) {
        for (let i = 0; i < subpedidos.length; i++) {
          var produtos = subpedidos[i].produtosPedido
          var totalPedido = this.calculaValorSubpedido(produtos)
          var pedido = {
            cam_campanha_id: this.pedidoPrincipalInfo.cam_campanha_id,
            cam_cond_pgto_id: this.pedidoPrincipalInfo.cam_cond_pgto_id,
            cam_pessoa_id: this.pedidoPrincipalInfo.cam_pessoa_id,
            farmacia_id: subpedidos[i].id,
            total: totalPedido,
            situacao: subpedidos[i].situacao ? subpedidos[i].situacao : 'A',
            created_user: parseInt(this.$store.getters['user'][0].usuario),
          }

          if (subpedidos[i].fazer_pedido) {
            var http = new service('CAM_PEDIDO')
            await http
              .create({ pedido: pedido, produtos: produtos })
              .then((resp) => {
                this.$emit('onChangeForm', resp.data.response)
              })
              .catch((e) => {
                this.$toast.error(e.response.data.message)
              })
          }
        }
        this.$store.commit({
          type: 'setMultiplosPedidos',
          value: [],
        })
        this.$toast.success('Registro(s) Criado com Sucesso!')
      }

      this.show_overlay = false
      window.clearInterval(this.interval_id)
      this.$emit('onChangeCloseModal')
    },
    async getListaFarmacias() {
      this.show_overlay = true
      this.listaPedidosInfos = this.$store.getters['multiplosPedidos']
      this.listaPedidosInfos.forEach(async (pedidoFarmacia) => {
        await this.validaPedido(pedidoFarmacia)
      })

      this.show_overlay = false
    },
    async validaPedido(pedido) {
      const quantidadeValida = this.validaQuantidade(pedido)
      const farmaciaValida = await this.validaFarmaciarRepetida(pedido)
      const condPgtoValido = await this.validaCondPgto(pedido)
      pedido.ehValido = quantidadeValida && farmaciaValida && condPgtoValido

      if (pedido.ehValido) {
        pedido.mensagem = 'Pedido Válido'
      }

      this.$store.commit({
        type: 'setMultiplosPedidos',
        value: this.listaPedidosInfos,
      })
    },
    async validaCondPgto(pedido) {
      var condicaoPagamentoValida = true
      const condPgtoID = this.pedidoPrincipalInfo.cam_cond_pgto_id
      const campanhaId = this.pedidoPrincipalInfo.cam_campanha_id
      const httpCondPgto = new service(
        `default/CAM_CAMPANHA_COND_PGTO/search/params?&cam_campanha_id=${campanhaId}&join=[{'table':'CAM_COND_PGTO','input':'ID','return':'DESC,NUMERO_PARCELAS'}]`,
      )
      const condPgto = await httpCondPgto.find().then((resp) => {
        return resp.data.response.find(
          (item) => item.cam_cond_pgto_id == condPgtoID,
        )
      })

      var valorTotal = 0
      const listaProdutos = pedido.produtosPedido
      for (let i = 0; i < listaProdutos.length; i++) {
        const produto = listaProdutos[i]
        valorTotal +=
          produto.quant_solicitada != null
            ? parseFloat(
                parseInt(produto.quant_solicitada) *
                  parseFloat(produto.valor_unitario),
              )
            : 0
      }
      const valorParcelaPedido = valorTotal / parseInt(condPgto.numero_parcelas)
      const valorMinimoPedido =
        this.$store.getters['pedidoInfo'].valor_minimo || 0
      if (valorParcelaPedido < parseInt(condPgto.valor_minimo_parcela)) {
        pedido.mensagem =
          'Valor das parcelas do pedido é inferior ao valor mínimo de parcela da condição de pagamento selecionada!'
        condicaoPagamentoValida = false
      } else if (valorTotal < valorMinimoPedido) {
        pedido.mensagem =
          'Valor total do pedido é inferior ao valor mínimo da campanha!'
        condicaoPagamentoValida = false
      }

      return condicaoPagamentoValida
    },
    validaQuantidade(pedido) {
      const produtos = pedido.produtosPedido
      var quantidadeValida = true
      for (let i = 0; i < produtos.length; i++) {
        if (
          (produtos[i].compra_obrigatorio == 'S' &&
            parseInt(produtos[i].quant_solicitada) <
              parseInt(produtos[i].quant_minima)) ||
          (parseInt(produtos[i].quant_minima) >
            parseInt(produtos[i].quant_solicitada) &&
            parseInt(produtos[i].quant_minima) > 0 &&
            parseInt(produtos[i].quant_solicitada) > 0) ||
          (produtos[i].quant_solicitada == null &&
            produtos[i].compra_obrigatorio == 'S')
        ) {
          pedido.mensagem =
            'Quantidade mínima de produtos não atingida! Verifique a quantidade dos produtos.'
          quantidadeValida = false

          break
        }
      }

      return quantidadeValida
    },
    async validaFarmaciarRepetida(pedido) {
      const listaPedidosCampanha = await this.getListaPedidosCampanha()
      var farmaciaValida = true
      for (let j = 0; j < listaPedidosCampanha.length; j++) {
        if (listaPedidosCampanha[j].farmacia_id == pedido.id) {
          pedido.mensagem = 'Esta farmácia já possui pedido para esta campanha!'
          farmaciaValida = false
          break
        }
      }

      return farmaciaValida
    },
    async getListaPedidosCampanha() {
      var listaPedidosCampanha = []
      const campanhaId = this.pedidoPrincipalInfo.cam_campanha_id
      var http = new service(`CAM_PEDIDO/${campanhaId}`)
      await http.find().then((resp) => {
        listaPedidosCampanha = resp.data.response
        this.show_overlay = false
        this.key++
      })

      return listaPedidosCampanha
    },
  },
  watch: {
    listaPedidosInfos: {
      deep: true,
      handler: function () {
        this.$emit('decideCorMaisFarmacias')
      },
    },
    onChangeCloseModal() {
      window.clearInterval(this.interval_id)
    },
  },
}
</script>
<style>
.status {
  position: relative;
  top: 7px;
}

div .status {
  border-radius: 5px;
}
</style>
